export const SERVER_URL =
    process.env.NODE_ENV === "production"
        ? "https://api.readinglist.design"
        : "https://localhost:443";



// WEBPACK FOOTER //
// ./src/api/constants.js